/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
    componentClass: 'input',
    type: 'text',
};

const FormInput = (props) => {
    const classNames = [
        'c-form-input',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            type={props.type}
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        />
    );
};

FormInput.propTypes = propTypes;

FormInput.defaultProps = defaultProps;

export default FormInput;
